module.exports = __webpack_public_path__ + "static/crowdsourcing-70c9dfc1b1f4da1acb52d13b8ec5ec86.jpg";